(function ( $ ) {
	$.fn.fields_block = function ( options ) {
		options = $.extend({
			list_itm         : '.fields_block__itm',
			max_count_on_line: 3,
			elem_name        : 'направлений'    //название элемента используется в кнопке еще
		}, options);

		var make = function () {
			var self      = this,	// перепишем объект
			    mql       = window.matchMedia('all and (max-width: 1000px)'),
			    is_mobile = mql.matches;

			$(document).ready(function () {

				// инициация слайдера
				var items = $(self).find('.fields_block__itm'),
				    count = items.size();

				init();

				function init() {
					// если количество блоков меньше минимального -> уходим
					if( count <= options.max_count_on_line ) return;

					var elem = $(self).find('.fields_block__itm:nth-child(n+' + (options.max_count_on_line + 1) + ')');
					elem.wrapAll('<div class="fields_block__more_block"></div>');
					elem.wrapAll('<div class="fields_block__more_block__flex"></div>');
					$(self).after("<div class='fields_block__more_btn more' data-active='false'>Все " + count + " " + make_name(count,options.elem_name) + "</div>");

				}


				$(self).parent().find('.fields_block__more_btn').click(function () {
					var btn = $(this);

					if( btn.attr('data-active') === 'false' ) {
						$(self).find('.fields_block__more_block').slideDown(300);
						btn.html('скрыть ' + make_name(-1,options.elem_name));
						btn.addClass('active');
						btn.attr('data-active', 'true');
					} else {
						$(self).find('.fields_block__more_block').slideUp(300);
						btn.html("Все " + count + " " + make_name(count,options.elem_name) );    //todo склонения
						btn.removeClass('active');
						btn.attr('data-active', 'false');
					}

				});


				$(window).on('resize', function () {
					mql = window.matchMedia('all and (max-width: 1000px)'),
						is_mobile = mql.matches;
				});


			});


			function make_name(count,name){

				count = count % 10;
				if(name==="проект") {

					if( count === 2 || count === 3 || count === 4 ) {
						return name + "а";
					}

					if( count === 0 || count === 5 || count === 6 || count === 7 ||
						count === 8 || count === 9 || count === 11 || count === 12 ||
						count === 13 || count === 14 )
					{
						return name + "ов";
					}

					if(count === -1){
						return name + "ы";
					}

				}

				if(name === "направлени"){

					if( count === 0 || count === 5 || count === 6  || count === 7  || count === 8  || count === 9 || count === 11 || count === 12 || count === 13 || count === 14 ) {
						return name + "й";
					}

					if( count === 1 ) {
						return name + "е";
					}

					if( count === -1 ||count === 2 || count === 3 || count === 4 ) {
						return name + "я";
					}

				}

				return name;
			}

		};

		return this.each(make);
	};
})(jQuery);